// Utils
import { dateStringFormatter } from './dateStringFormatter';
/**
 * @description This is used to convert a Date object into an String matching the
 * ISO 8601 standard with the seconds and timezone information stripped (Y-D-MTh:m).
 *
 * @param {Date} date - Date object to be converted.
 * @param {string} locale - The Users locale, the value passed in must be a valid
 * JS date object locale string.
 * @param {string} timeZone - The Users timezone, the value passed in must be a valid
 * JS Date object timezone string.
 *
 * @returns { string } Returns a string value created from the given JS Date object.
 */
export var convertDateToFormattedString = function (date, locale, timeZone) {
    var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: timeZone,
    };
    var localeString = date.toLocaleString(locale, options).replace(', ', 'T');
    return dateStringFormatter(localeString);
};
//# sourceMappingURL=convertDateToFormattedString.js.map